export default function formatDEFrameworkValue(value) {
  return value ? value.replace(".", ",") // Replace dot with comma for decimal separator
  .replace(/\B(?=(\d{3})+(?!\d))/g, ".") // Add dots for thousands
  .replace(/,(\d)$/, ",$10") // Pad decimals with zero if necessary
  .replace(/,(\d)\b/, ",$1") // Ensure decimals are always two characters
  : '';
}